import { render } from "./EmployeeJob.vue?vue&type=template&id=08d5c06c&scoped=true"
import script from "./EmployeeJob.vue?vue&type=script&lang=js"
export * from "./EmployeeJob.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=08d5c06c&lang=scss&scoped=true"
import "./EmployeeJob.vue?vue&type=style&index=1&id=08d5c06c&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d5c06c"]])

export default __exports__